// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBmMJ1vc5GkuDwin_qqHosYlmGMy3Pwj98",
  authDomain: "futurehelper-27d7a.firebaseapp.com",
  projectId: "futurehelper-27d7a",
  storageBucket: "futurehelper-27d7a.firebasestorage.app",
  messagingSenderId: "756319616605",
  appId: "756319616605:web:4322820390a9100cde57b4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
